import { CaretRightIcon } from '@bloomfieldrobotics/canopy';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  accordionSummaryClasses,
  AccordionSummaryProps,
  styled,
  Typography,
} from '@mui/material';
import { PropsWithChildren, useState } from 'react';

type Props = PropsWithChildren<{
  displayDate: string;
  defaultExpanded?: boolean;
}>;

const StyledAccordionSummary = styled((props: AccordionSummaryProps) => (
  <AccordionSummary
    expandIcon={<CaretRightIcon fontSize='small' />}
    {...props}
  />
))(({ theme }) => ({
  paddingLeft: 1.5,
  paddingRight: 1.5,
  paddingTop: 0.5,
  paddingBottom: 0.5,
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    [`&.${accordionSummaryClasses.expanded}`]: {
      transform: 'rotate(90deg)',
    },
  },
  [`& .${accordionSummaryClasses.content}, & .${accordionSummaryClasses.content}.Mui-expanded`]:
    {
      marginLeft: theme.spacing(1),
    },
}));

export const ReportChartContainer = ({
  displayDate,
  defaultExpanded = true,
  children,
}: Props) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, expanded) => setExpanded(expanded)}
      disableGutters
      sx={{
        width: '100%',
      }}
    >
      <StyledAccordionSummary>
        <Typography variant='subtitle2'>{displayDate}</Typography>
      </StyledAccordionSummary>
      <AccordionDetails
        sx={{
          width: '100%',
          paddingLeft: 4,
          paddingRight: 4,
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
